module.exports = __webpack_public_path__ + "img/logo-black.2032955d.svg";